import Environment from './IEnvironment';

export const environment: Environment = {
  name: 'dev',
  production: true,
  host: 'https://bh.jhn.ngo',
  relationsServiceHost: 'https://bh.jhn.ngo',
  socketioUrl: 'https://bh.jhn.ngo',
};
